module.exports = __webpack_public_path__ + "img/home-content-two.85ef019b.png";